import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDatatableHeaderAnchor]',
})
export class DatatableHeaderAnchorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
